<template>
  <div class="module-wrapper linebottomg" style="margin-right: 9px;
  padding-right: 0px;">
    <div v-for="(item, index) in basicData" :key="index"
    :class="index === 0?'item-wrapper-f':index === 1?'item-wrapper-n':'item-wrapper'"
    @click="clickindex(index)">
      <div :class="index === 0?'item-text-f':index === 1?'item-text-n':'item-text'">
        <div class="titlename">{{`${item.title}`}}</div>
        <img src="@/assets/right-arrow-gray.png"
         alt=""
         class="right-arrow"/>
      </div>
      <div :class="index === 0?'item-sub-v-f':index === 1?'item-sub-v-n':'item-sub-v'">
        <div
          :class="index === 0?'item-subtitle-f':index === 1?'item-subtitle-n':'item-subtitle'"
          :style="{color: item.subTitleColor || '#000000'}"
        >{{item.subtitle}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import JS from '@/base/JSTool';
import NativeMsg from '@/base/NativeMsg';
import FundTypeSearch from '@/utils/FundTypeSearch';
import StoreManger from '@/utils/FundHQJHManger';
import {
  detailPushPage,
} from '@/utils/nativeBridge';

export default {
  name: 'FundGeneralSituation',
  components: {
  },
  data() {
    return {
      dataPZKGZH: {},
      dataInfo: {},
      dataSp: {},
      dataCfh: {},
      clrdate: '--',
      tlxSubTitle: '',
      xgztSubTitle: '',
      spSubTitle: '',
      cfhSubTitle: '',
      cfhLink: {},
      gsSubTitle: '',
      cfhID: '',
      cfhImgPath: '',
      basicData: [],
    };
  },
  created() {
    NativeMsg.reg('reflashHQB', () => {
      this.configureHQB();
    });
  },
  mounted() {
    this.render();
  },
  methods: {
    clickindex(index) {
      if (index === 0) {
        this.goToFunDGDDetailInfo();
      }
      if (index === 1) {
        const baseInfo = StoreManger.getFundJJXQ();
        const name = StoreManger.getFundJJXQNAME(baseInfo);
        const code = StoreManger.getFundJJXQCODE(baseInfo);
        detailPushPage({
          appId: 'b34ccfc4ed9a4af4a4880fee485cf417',
          url: '/pages/Index',
          params: {
            fundCode: code,
            fundName: name,
            index: '0',
          },
        });
      }
      if (index === 2) {
        const baseInfo = StoreManger.getFundJJXQ();

        const name = StoreManger.getFundJJXQNAME(baseInfo);
        const code = StoreManger.getFundJJXQCODE(baseInfo);
        detailPushPage({
          appId: 'b34ccfc4ed9a4af4a4880fee485cf417',
          url: '/pages/Index',
          params: {
            fundCode: code,
            fundName: name,
            index: '2',
          },
        });
        this.reportMonitor({
          eventName: 'pz.xx.jjgm.click',
        });
      }
    },
    render2() {},
    render() {
      this.nativeData = this.$store.state.native.fund;
      this.fundCode = this.nativeData.fundCode;
      this.fundType = this.nativeData.fundType;
      this.dataInfo = StoreManger.getFundJJXQ();
      this.loadData();
    },
    configureHQB() {
      this.dataCfh = this.$store.state.cfhModules.fund[this.fundCode];
      if (this.dataCfh) {
        const { cfhinfos } = this.dataCfh;
        if (cfhinfos && cfhinfos.length > 0) {
          const cfhInfo = cfhinfos[0];
          if (cfhInfo.cfhname) {
            this.cfhSubTitle = cfhInfo.cfhname;
            this.cfhID = cfhInfo.cfhid;
            this.cfhLink = {
              LinkType: 2,
              AdId: 0,
              LinkTo: cfhInfo.link.linkTo ? cfhInfo.link.linkTo : '',
            };
            this.cfhImgPath = cfhInfo.headerimgpath;
          }
        }
      }
    },
    async loadData() {
      this.dataInfo = StoreManger.getFundJJXQ();
      this.clrdate = `${this.format(this.dataInfo, 'ESTABDATE')}`;
      if (this.clrdate === '--') {
        this.clrdate = '--';
      }
      if (FundTypeSearch.isNewFund(this.fundType)) {
        this.clrdate = '等待成立';
      }
      this.configureHQB();
      this.configurenextgk();
    },
    configurenextgk() {
      const arr = [];
      const JJGS = this.format(this.dataInfo, 'JJGS');
      arr.push({
        title: '基金公司',
        subtitle: `${JJGS}`,
        target: () => {
          this.goToFunDGDDetailInfo();
        },
      });
      arr.push({
        title: '成立时间',
        subtitle: this.clrdate,
        target: () => {
          this.goToDetailInfo();
        },
      });
      let gm = '--';
      const GMres = StoreManger.getFundJJGM();
      const gmList = GMres ? GMres.Datas : null;
      if (gmList) {
        const gmitem = gmList[0];
        if (gmitem) {
          const nav = gmitem.NETNAV;
          if (nav) {
            if (nav >= 1000000) {
              const scaleAllMoneys = nav / 100000000;
              const tt = scaleAllMoneys.toFixed(2);
              gm = `${tt}亿`;
            } else if (nav >= 100) {
              const scaleAllMoneys = nav / 10000;
              const tt = scaleAllMoneys.toFixed(2);
              gm = `${tt}万`;
            } else {
              gm = nav;
            }
          }
        }
      }
      if (FundTypeSearch.isNewFund(this.fundType)) {
        gm = '--';
      }
      arr.push({
        title: '基金规模',
        subtitle: gm,
        target: () => {
          this.goToDetailInfo();
        },
      });
      this.basicData = arr;
    },
    format(item, key) {
      const res = JS.fetchString(item, key);
      return res || '--';
    },
    clickCell(item) {
      if (item.target) {
        item.target();
      }
      if (item.title === '概况') {
        this.reportMonitor({
          eventName: 'pz.xx.gk',
        });
      }
      if (item.title === '同类型基金') {
        this.reportMonitor({
          eventName: 'pz.xx.tlx',
        });
      }
      if (item.title === '相关主题') {
        this.reportMonitor({
          eventName: 'pz.xx.xgzt',
        });
      }
      if (item.title === '持有该基金的组合') {
        this.reportMonitor({
          eventName: 'pz.xx.gk.sp',
        });
      }
      if (item.title === '财富号') {
        this.reportMonitor({
          eventName: 'pz.xx.cfh',
        });
      }
    },
    goToFunDGDDetailInfo() {
      if (this.cfhLink.LinkTo) {
        //
        const { LinkType, LinkTo } = this.cfhLink;
        detailPushPage({
          type: LinkType,
          url: LinkTo,
        });
      } else {
        const JJGSID = this.format(this.dataInfo, 'JJGSID');
        //
        const url = `https://appunit.1234567.com.cn/FundCompany/index.html?isapp=1&fundCompany=${JJGSID}`;
        detailPushPage({
          type: '2',
          url,
        });
      }
    },
    goToFunCfh() {
      const JJGSID = this.format(this.dataInfo, 'JJGSID');
      //
      const url = `https://appunit.1234567.com.cn/FundCompany/index.html?isapp=1&fundCompany=${JJGSID}`;
      detailPushPage({
        type: '2',
        url,
      });
    },
    goToDetailInfo() {
      const baseInfo = StoreManger.getFundJJXQ();
      const code = StoreManger.getFundJJXQCODE(baseInfo);
      detailPushPage({
        appId: 'b34ccfc4ed9a4af4a4880fee485cf417',
        url: '/pages/FundDetailInfo',
        params: {
          FCODE: code,
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.module-wrapper {
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  justify-content: space-between;
  margin-top: 30px;
  padding-bottom: 30px;
  margin-right: 0px;
  padding-right: 0px;
}

.item-wrapper {
  display: flex;
  flex-direction: column;
  width: 33%;
}
.item-wrapper-f{
  display: flex;
  flex-direction: column;
  width: 33%;
  justify-content: flex-end;
}
.item-wrapper-n{
  display: flex;
  flex-direction: column;
  width: 33%;
  justify-content: center;
}
.item-text {
  display: flex;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  align-items: center;
  letter-spacing: 0;
  color: #666666;
  flex-direction: row;
  margin-bottom: 16px;
  justify-content: flex-end;
}
.titlename{
  white-space:nowrap;
  line-height: normal;
}
.item-text-f{
  display: flex;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  align-items: center;
  letter-spacing: 0;
  color: #666666;
  flex-direction: row;
  margin-bottom: 14px;
}
.item-text-n{
  display: flex;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  align-items: center;
  letter-spacing: 0;
  color: #666666;
  flex-direction: row;
  margin-bottom: 16px;
  justify-content: center;
  padding-left: 8px;
}
.item-sub-v-f{
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
}
.item-sub-v{
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.item-sub-v-n{
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.item-title {
  font-size: 28px;
  letter-spacing: 0;
  color: #666666;
  color: #000000;
  flex: 1;
}
.item-subtitle-f {
  font-weight: bold;
  font-size: 32px;
  line-height: 40px;
  color: #666666;
  width: 180px;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-align: left;
}
.item-subtitle {
  font-family: DINAlternate-Bold;
  font-size: 32px;
  line-height: 40px;
  color: #666666;
  width: 180px;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-align: center;
}
.item-subtitle-n {
  font-family: DINAlternate-Bold;
  font-size: 32px;
  line-height: 40px;
  color: #666666;
  width: 180px;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-align: center;
}

.right-arrow {
  width: 28px;
  height: 28px;
}

.item-icon {
  width: 28px;
  height: 28px;
  margin-right: 10px;
}
</style>
